import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { apiTokenInterceptor } from './core/interceptors/api-token.interceptor';
import { correlationInterceptor } from './core/interceptors/correlation.interceptor';
import { pageSizeInterceptor } from './core/interceptors/page-size.interceptor';
import { ClientErrorHandler } from './core/observability/client-error-handler';
import { ErpToastrService } from './core/observability/erp-toastr.service';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { importProvidersFrom } from '@angular/core';
import { provideToastr, ToastrService } from 'ngx-toastr';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RevalidatingTranslateLoader } from './core/i18n/revalidating-translate-loader';
import { CountryTextService } from './application/services/country-text.service';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([apiTokenInterceptor, correlationInterceptor, pageSizeInterceptor])),
    // OPS-02: browser errors reach the API's logs; error toasts after a failed call show its reference.
    { provide: ErrorHandler, useClass: ClientErrorHandler },
    { provide: ToastrService, useClass: ErpToastrService },
    // Expired session (401) → login; subscription ended / company closed (403) → renewal page / login.
    // The class existed but was never registered.
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, 
    provideAnimations(), 
  provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 4000,
      closeButton: true,
      progressBar: true,
    }), 
  importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'en',
        // Always revalidates /assets/i18n/<lang>.json, so new keys never show as raw keys.
        loader: { provide: TranslateLoader, useFactory: () => new RevalidatingTranslateLoader('/assets/i18n/', '.json') }
      })
    ),
    // REV-17: country.<CODE>.* texts replace the neutral ones once the company's pack is known.
    provideAppInitializer(() => { inject(CountryTextService); }),
    // OPS-03-T01: the installable shell (app shell + static assets only — API answers are never cached, see ngsw-config.json).
    // Off in the local and e2e builds: a worker outliving `ng serve` would serve stale bundles. The header offers the update.
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]

};
